import { type } from "@ngrx/signals";
import { entityConfig } from "@ngrx/signals/entities";
import { StoreCollection } from "src/app/enums";
// Import all DTOs from the same API service (event service)
import { CouponEventDto } from "src/app/services/api/event/model/coupon-event-dto";
import { MembershipEventDto } from "src/app/services/api/event/model/membership-event-dto";
import { UserCredentialsEventDto } from "src/app/services/api/event/model/user-credentials-event-dto";
import { UserRegistrationEventDto } from "src/app/services/api/event/model/user-registration-event-dto";
import { NewsEventDto } from "src/app/services/api/event/model/news-event-dto";
import { UserEventDto } from "src/app/services/api/event/model/user-event-dto";
import { AccountEventDto } from "src/app/services/api/event/model/account-event-dto";
import { AccountMergedEventDto } from "src/app/services/api/event/model/account-merged-event-dto";
import { AccountIdentifierEventDto } from "src/app/services/api/event/model/account-identifier-event-dto";
import { AccountIdentifierMergedEventDto } from "src/app/services/api/event/model/account-identifier-merged-event-dto";
import { AccountFraudEventDto } from "src/app/services/api/event/model/account-fraud-event-dto";
import { AccountMembershipEventDto } from "src/app/services/api/event/model/account-membership-event-dto";
import { AccountStatusLevelEventDto } from "src/app/services/api/event/model/account-status-level-event-dto";
import { WorkflowEventDto } from "src/app/services/api/event/model/workflow-event-dto";

export type CustomerEventDto =
  | UserEventDto
  | UserRegistrationEventDto
  | UserCredentialsEventDto
  | MembershipEventDto
  | AccountEventDto
  | AccountMergedEventDto
  | AccountIdentifierEventDto
  | AccountIdentifierMergedEventDto
  | AccountFraudEventDto
  | AccountMembershipEventDto
  | AccountStatusLevelEventDto;

export type EventDto = CouponEventDto | NewsEventDto | CustomerEventDto | WorkflowEventDto;

export type EventWithSubject = Exclude<EventDto, AccountEventDto | AccountMergedEventDto>;

interface EventsState {
  couponEvents: CouponEventDto[];
  postEvents: NewsEventDto[];
  customerEvents: CustomerEventDto[];
  workflowEvents: WorkflowEventDto[];
}

export const initialState: EventsState = {
  couponEvents: [],
  postEvents: [],
  customerEvents: [],
  workflowEvents: [],
};

export const couponEventsConfig = entityConfig({
  entity: type<CouponEventDto>(),
  collection: StoreCollection.CouponEvents,
});

export const postEventsConfig = entityConfig({
  entity: type<NewsEventDto>(),
  collection: StoreCollection.PostEvents,
});

export const customerEventsConfig = entityConfig({
  entity: type<CustomerEventDto>(),
  collection: StoreCollection.CustomerEvents,
});

export const workflowEventsConfig = entityConfig({
  entity: type<WorkflowEventDto>(),
  collection: StoreCollection.WorkflowEvents,
});
